import { FormikProps } from 'formik';

export interface AutoBroadcastProps {
    id: number;
    broadcast_id: number;
    chat_id: string;
    full_name: string;
    user_name: string;
    telegramId: number;
    type_label: AutoBroadcastTrigger;
    status: AutoBroadcast;
    error_message: string | null;
    created_at: Date;
    content: AutoBroadcastContent;
}

export interface AutoBroadcastContent {
    broadcast_id: number;
    id: number;
    media_caption: string;
    media_url: string;
    menu: string;
    message: string;
    type: number;
}

export type AutoBroadcastTrigger =
    | 'Брошенная корзина'
    | 'Массовая рассылка'
    | 'Брошенная сессия';

export const autoBroadcastType = {
    no_cart: 'no_cart',
    no_order: 'no_order',
} as const;

export type AutoBroadcast = keyof typeof autoBroadcastType;

export interface AutoBroadcastValues {
    is_enabled: boolean;
    text: string;
    send_after: number;
    type: AutoBroadcast;
    image?: string | null;
}

export interface AutobroadcastFormComponentProps {
    fieldName: string;
    formik: FormikProps<AutoBroadcastValues>;
    title?: string;
    isEdit?: boolean;
}
